import React from 'react';
import { Outlet } from 'react-router-dom';
import { LayoutGroup, motion } from 'motion/react';
import { PageProvider, usePageContext } from '../../../contexts/PageContext';
import Sidebar from '../Sidebar';
import AppHeader from './AppHeader/AppHeader';
import { ToastProvider } from '../../../contexts/ToastContext';
import ToastContainer from '../../ui/toast/ToastContainer';
import { dashboardTransitions } from 'lib/motion/dashboardMotion';

const AppLayoutInner: React.FC = () => {
  const { pageConfig } = usePageContext();
  const isEditorLayout = pageConfig.layout === 'editor';

  return (
    <LayoutGroup id="app-shell-layout">
      <div className="flex h-screen bg-gray-50">
        {/* Sidebar */}
        <Sidebar />

        {/* Main content area */}
        <motion.div
          layout
          transition={dashboardTransitions.layoutStrong}
          className="flex flex-1 flex-col overflow-hidden"
        >
          {!isEditorLayout && <AppHeader />}

          {/* Page Content */}
          <main className="flex-1 overflow-y-auto">
            <Outlet />
          </main>
        </motion.div>
      </div>
    </LayoutGroup>
  );
};

const AppLayout: React.FC = () => {
  return (
    <ToastProvider>
      <PageProvider>
        <AppLayoutInner />
        {/* Top-level toasts keep notices consistent across routes. */}
        <ToastContainer />
      </PageProvider>
    </ToastProvider>
  );
};

export default AppLayout;
